<script setup>
defineProps({
  show: { type: Boolean, default: false },
});

const emit = defineEmits(["close"]);

function closeModal() {
  emit("close");
}
</script>

<template>
  <div
    v-if="show"
    class="fixed inset-0 z-[9998] flex items-center justify-center bg-black/20"
    @click.self="closeModal"
  >
    <div
      class="bg-surface rounded-lg p-4 max-w-md w-full shadow-lg max-h-[80vh] overflow-y-auto"
    >
      <h2 class="text-xl font-semibold mb-3">
        Sobre a seção de usuários
      </h2>

      <p
        class="text-sm leading-relaxed text-gray-800 mb-3"
      >
        Nesta página você gerencia os usuários do sistema. Aqui é possível
        cadastrar novas contas, ajustar dados de acesso, ativar ou desativar
        usuários e acompanhar métricas de uso relacionadas a textos, notas e
        onboarding.
      </p>

      <ul
        class="list-disc pl-5 text-sm text-gray-700 space-y-1.5 mb-3"
      >
        <li>
          Use o campo de busca para localizar usuários rapidamente pelo nome
          ou e-mail.
        </li>
        <li>
          Clique em <strong>Adicionar Usuário</strong> para criar uma nova
          conta. Os detalhes mais avançados (como perfil, grupos e permissões)
          podem ser ajustados em outras telas específicas.
        </li>
        <li>
          Na coluna <strong>Ações</strong>, use o menu de três pontos para
          <strong>editar</strong>, <strong>visualizar</strong> os detalhes ou
          <strong>excluir</strong> um usuário (quando permitido pelas regras
          de segurança).
        </li>
        <li>
          A coluna <strong>Status</strong> indica se o usuário está ativo ou
          inativo. Normalmente, desativar um usuário é preferível a excluí-lo,
          pois preserva o histórico de atividades.
        </li>
        <li>
          As colunas <strong>Usuários</strong>, <strong>Textos</strong> e
          <strong>Notas</strong> exibem contadores associados ao plano ou ao
          uso do sistema, ajudando a monitorar limites e engajamento.
        </li>
        <li>
          A coluna <strong>Onboarding</strong> indica se o usuário já
          concluiu o fluxo inicial de configuração/boas-vindas na aplicação.
        </li>
        <li>
          Marque vários usuários na primeira coluna para realizar
          <strong>exclusões em lote</strong> pelo menu
          <strong>Ações em lote</strong>, respeitando as restrições de
          segurança e permissão.
        </li>
        <li>
          Os campos de <strong>Criação</strong> e <strong>Atualização</strong>
          ajudam a auditar quando cada conta foi criada e quando sofreu a
          última alteração cadastral.
        </li>
      </ul>

      <div class="mt-2 text-right">
        <button
          @click="closeModal"
          class="px-3 py-1.5 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition"
        >
          Fechar
        </button>
      </div>
    </div>
  </div>
</template>


